/// <reference path="../../../typings/tsd.d.ts" />
module warsApp.directives {
    export interface IAddFeatureConfigurationScope extends angular.IScope {
        configuration: Wars.Domain.Model.Gis.AddFeaturesConfiguration;
        addAttribute: any;
        deleteAttribute: any;
        gisDatastoreChanged:any;
        save: any;
        inputCollection: Wars.Domain.Model.Gis.GisInputOutputCollection;
        gisDatastores: Wars.Domain.Model.Gis.GisDatastore[];
        currentGisDatastoreAttributes: any;
        codeGroups: Wars.Domain.Model.Codes.CodeGroup[];
        javascriptTransformers:Wars.Domain.Model.Gis.JavascriptTransformer[];
    }

    export class AddFeaturesConfiguration implements IDirective {
        public link($scope: IAddFeatureConfigurationScope, element: JQuery, attrs: ng.IAttributes) {
        }

        public templateUrl = "./app/views/directives/gis/addFeaturesConfiguration.html";
        public restrict: string = "E";
        public controller = [
            "$scope", 'mapConfigurationService', 'gisDatastoreService','systemLevelService',AddFeaturesConfigurationController
        ];
        public controllerAs = "controller";
        public scope: any = {
            configuration: "=",
            inputCollection: "=",
            mapConfiguration:"="
        };
    }

    export class AddFeaturesConfigurationController {
        constructor(private $scope: IAddFeatureConfigurationScope,
            private mapConfigurationService: services.MapConfigurationService,
            private gisDatastoreService: services.GisDatastoreService,
            private systemLevelService:services.SystemLevelService) {

            $scope.save = () => mapConfigurationService.saveAllChanges();
            $scope.addAttribute = () => this.addAttribute();
            $scope.gisDatastoreChanged = () => this.gisDatastoreChanged();
            $scope.deleteAttribute = (a) => this.deleteAttribute(a);

            this.gisDatastoreService.getGisDatastores().then(stores => {
                this.$scope.gisDatastores = stores;
            });

            this.systemLevelService.getSystemLevelCodes().then(systemLevel => {
                this.$scope.codeGroups = systemLevel.myCodeGroups;
            });

            if ($scope.configuration.gisDatastore) {
                this.setupGisDatastoreAttributes();
            }
        }

        private gisDatastoreChanged() {
            this.setupGisDatastoreAttributes();
            this.mapConfigurationService.saveAllChanges();
        }

        private setupGisDatastoreAttributes() {
            this.$scope.currentGisDatastoreAttributes = [];
            if (this.$scope.configuration.gisDatastore) {
                for (let i = 1; i < 21; i++) {
                    if (this.$scope.configuration.gisDatastore['metadata' + i + 'PropertyName']) {
                        this.$scope.currentGisDatastoreAttributes.push({
                            name: this.$scope.configuration.gisDatastore['metadata' + i + 'PropertyName'],
                            index: i
                        });
                    }
                }
            }
        }

        private addAttribute() {
            let newAttr = this.mapConfigurationService.createFeatureAttributeToPropertyMap();
            newAttr.attributeNumber = this.$scope.configuration.featureAttributeToPropertyMaps.length;

            this.$scope.configuration.featureAttributeToPropertyMaps.push(newAttr);

            this.mapConfigurationService.saveAllChanges();

        }

        private deleteAttribute(attr: Wars.Domain.Model.Gis.FeatureAttributeToPropertyMap) {
            attr.entityAspect.setDeleted();

            this.mapConfigurationService.saveAllChanges();
        }
    }
}

warsApp.registerDirective('AddFeaturesConfiguration', []);